import React, { Fragment } from 'react';
import { withStyles } from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import WaveTextField from '../form/WaveTextField';

const styles = theme => ({
  profilingToolLabelFields: {
    marginBottom: theme.typography.pxToRem(10)
  }
});

class ProfilingToolLabelForm extends React.Component {

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <Grid
          container
          className={classes.profilingToolLabelFields}
          justifyContent="space-between"
        >
          <Grid size={12}>
            <WaveTextField
              label="Label"
              {...this.props.makeFieldProps('text')}
            />
          </Grid>
        </Grid>
      </Fragment>
    );
  }

}

export default withStyles(ProfilingToolLabelForm, styles, { withTheme: true });
